import { type ReactNode } from 'react'

// Enveloppe commune aux 4 sections de la page (Santé, État par famille, Suivi, Activité récente) :
// titre h2 + slot enfants, sans grille imposée — chaque section choisit la sienne au niveau de la page.
export default function DashboardSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-lg font-bold text-primary">{title}</h2>
      {children}
    </section>
  )
}
